import { createTheme, ThemeOptions } from '@mui/material';
import { merge, omit } from 'lodash';
//import _baseTheme from './base-theme-legacy.json';
import _baseTheme from './base-theme.json';
const baseTheme = omit(_baseTheme, ['components', 'spacing']);

export const lightChartColors = [
  '#0074DE',
  '#5E63D2',
  '#5D36B4',
  '#A126A0',
  '#D61C71',
  '#ED0020',
  '#EF4E00',
  '#FBA841',
  '#979F34',
  '#006753',
];

export const darkChartColors = [
  '#3AB3FF',
  '#7AA9FF',
  '#9E7DD7',
  '#D772C7',
  '#FF68A6',
  '#FF5C69',
  '#FF8549',
  '#FFBF47',
  '#CBE364',
  '#72C0B3',
];

export const indicatorColors = {
  good: '#47B56F',
  warning: '#FFC145',
  bad: '#E34E46',
  notReporting: '#848A94',
  charging: '#7673FF',
  discharging: '#B767E5',
  idle: '#56B4F0',
};

const indicator = {
  good: indicatorColors.good,
  warning: indicatorColors.warning,
  bad: indicatorColors.bad,
  notReporting: indicatorColors.notReporting,
  charging: indicatorColors.charging,
  discharging: indicatorColors.discharging,
  idle: indicatorColors.idle,
};

/****************
 * COMBINE BASE THEME WITH OVERRIDES
 * ****************/

const { colorSchemes, ...base } = baseTheme;

// prettier-ignore
export const elevations = {
  light: {
    card:'0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    cardSmallButton: '0px 1.5px 0px 0px rgba(255, 255, 255, 0.90) inset, 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
    cardSmallButton2: '0px 1.5px 0px 0px rgba(255, 255, 255, 0.90) inset, 0px 1px 4px 0px rgba(0, 92, 229, 0.25)',
    button: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px rgba(255, 255, 255, 0.50) inset;',
    secondaryButton:'0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #314561 inset',
    secondaryButtonPressed2: '0px 0px 2px 1px rgba(0, 92, 229, 0.20) inset, 0px 0px 0px 1px rgba(0, 92, 229, 0.10) inset, 0px 1.5px 0px 0px #FFF;',
    primaryButton:'0px 5px 8px 0px rgba(0, 92, 229, 0.20), 0px 1px 2px 0px rgba(0, 92, 229, 0.20), 0px 1.5px 0px 0px rgba(255, 255, 255, 0.70) inset',
    primaryButton2:'0px 5px 8px 0px rgba(0, 92, 229, 0.20), 0px 1px 2px 0px rgba(0, 92, 229, 0.20), 0px 1.5px 0px 0px rgba(255, 255, 255, 0.70) inset',
    primaryButtonPressed2: '0px 0px 2px 1px #000 inset, 0px 1.5px 0px 0px #FFF',
    hoverButtonPressed: "0px 0px 2px 1px rgba(0, 92, 229, 0.20) inset, 0px 0px 0px 1px rgba(0, 92, 229, 0.10) inset, 0px 1.5px 0px 0px #FFF",
    hoverButton: '0px 1.5px 0px 0px #FFF inset, 0px 1px 4px 0px rgba(0, 92, 229, 0.25)',
  },
  dark: {
    card:'0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    button:'0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #314561 inset',
    cardSmallButton: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #475762 inset',
    cardSmallButton2: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #343E47 inset',
    secondaryButtonPressed2: '0px 0px 2px 1px #000 inset, 0px 1.5px 0px 0px #2E3E55',
    primaryButton:'0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 0px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #00CDC6 inset',
    primaryButton2Disabled: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 0px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #2D3C52 inset',
    primaryButton2: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 0px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #343E47 inset',
    primaryButtonPressed2: '0px 0px 2px 1px #000 inset, 0px 1.5px 0px 0px #2E3E55',
    hoverButtonPressed: "0px 0px 2px 1px #000 inset, 0px 1.5px 0px 0px rgba(135, 188, 255, 0.22)",
    hoverButton: '0px 5px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 1px rgba(0, 0, 0, 0.20), 0px 1.5px 0px 0px #2A3A52 inset'
  },
};
const themes = {} as {
  dark: ReturnType<typeof createTheme>;
  light: ReturnType<typeof createTheme>;
};

Object.keys(colorSchemes).forEach((key: 'light' | 'dark') => {
  const { palette } = colorSchemes[key];
  palette.mode = key;
  palette.elevations = elevations[key];
  const light = key !== 'dark';

  // legacy palette typographies and colors
  const legacyPalette = {
    default: palette.background['default'],
    surface1: palette.background['paperElevation0'],
    surface2: palette.background['paperElevation1'],
    surface3: palette.background['paperElevation2'],
    onBackground: palette.background['paperElevation0'],
    onSurface: palette.background['default'],
    outline: palette.background['paperElevation2'],
    disabled: palette.background['paperElevation3'],
    onPrimary: palette.background['paperElevation0'],
    onSecondary: palette.background['paperElevation1'],
    primary: {
      ...palette.primary,
      100: palette.primary['100'],
      200: palette.primary['200'],
      300: palette.primary['300'],
      400: palette.primary['light'],
      500: palette.primary['main'],
      600: palette.primary['dark'],
    },
    secondary: {
      ...palette.secondary,
      100: palette.secondary['100'],
      200: palette.secondary['200'],
      300: palette.secondary['300'],
      400: palette.secondary['light'],
      500: palette.secondary['main'],
      600: palette.secondary['dark'],
    },
    error: {
      ...palette.error,
      critical: palette.error.main,
    },
    warning: {
      ...palette.warning,
      atRisk: palette.warning.main,
    },
    success: {
      ...palette.success,
      good: palette.success.main,
    },
    info: {
      ...palette.info,
    },
    divider: palette.divider1,
    accent: palette.accent,
    notReporting: palette.notreporting,
    green: palette.green,
    blue: palette.blue,
    red: palette.red,
    orange: palette.orange,
    yellow: palette.yellow,
    lime: palette.lime,
    brown: palette.brown,
    foam: palette.foam,
    purple: palette.purple,
    pink: palette.pink,
    peach: palette.peach,
    chart1: palette.turquoise || '#0074DE',
    chart2: palette.purple || '#5E63D2',
    chart3: palette.pink || '#5D36B4',
    chart4: palette.peach || '#A126A0',
    chart5: palette.red || '#D61C71',
    chart6: palette.error.main || '#ED0020',
    chart7: palette.orange || '#EF4E00',
    chart8: palette.yellow || '#FBA841',
    chart9: palette.lime || '#979F34',
    chart10: palette.green || '#006753',
    text: {
      ...palette.text,
      highEmphasis: palette.text.primary,
      mediumEmphasis: palette.text.secondary,
      lowEmphasis: palette.text.tertiary,
      disabled: palette.text.disabled,
    },
    pdfBackground: '#FFFFFF',
    pdfSurface1: '#F8F8FA',
    pdfSurface2: '#F0F1F4',
    pdfOutline: '#E0E3E9',
    pdfTextHighEmphasis: '#1B2328',
    pdfTextMediumEmphasis: '#4B555B',
    pdfTextOnColor: '#FFFFFF',
    pdfPrimary: '#00B2A9',
    pdfPrimaryDark: '#006865',
    pdfPrimaryLight: '#B3E8E5',
    pdfSecondary: '#002D72',
    pdfSecondaryDark: '#00245B',
    pdfSecondaryLight: '#CCD5E3',
    pdfCritical: '#E64B39',
    pdfAtRisk: '#FFAB00',
    pdfGood: '#46A669',
    pdfNoData: '#7C878E',
    pdfChartPurple: '#5E63D2',
    pdfChartPink: '#D61C71',
    pdfChartOrange: '#EF4E00',
    pdfChartBlue: '#0074DE',
  };

  const legacyTypography = {
    h1: base.typography?.h1 || {},
    h2: base.typography?.h2 || {},
    h3: base.typography?.h3 || {},
    body: base.typography?.body1 || {},
    bodyBold: base.typography?.body2 || {},
    bodySmall: base.typography?.body3 || {},
    bodySmallBold: base.typography?.body4 || {},
    caption: base.typography?.caption1 || {},
    smallCaps: base.typography?.overline1 || {},
    mediumCaps: base.typography?.overline2 || {},
    largeCaps: base.typography?.overline3 || {},
    numbersXL: base.typography?.numbersXL || {},
    numbersLarge: base.typography?.numbersL || {},
    numbersMedium: base.typography?.numbersM || {},
    numbersSmall: base.typography?.numbersS || {},
    subtitle1: base.typography?.subtitle1 || {},
    subtitle2: base.typography?.subtitle2 || {},
    button: base.typography?.button || {},
    // Add any additional mappings as needed
  };

  const shadows = {
    25: baseTheme.shadows[key === 'dark' ? 25 : 26],
    26: baseTheme.shadows[key === 'dark' ? 27 : 28],
    27: baseTheme.shadows[key === 'dark' ? 29 : 30],
    28: baseTheme.shadows[key === 'dark' ? 31 : 32],
    29: baseTheme.shadows[key === 'dark' ? 33 : 34],
    30: baseTheme.shadows[key === 'dark' ? 35 : 36],
    31: baseTheme.shadows[key === 'dark' ? 37 : 38],
    32: baseTheme.shadows[key === 'dark' ? 39 : 40],
    33: baseTheme.shadows[key === 'dark' ? 41 : 42],
    34: baseTheme.shadows[key === 'dark' ? 43 : 44],
    35: baseTheme.shadows[key === 'dark' ? 45 : 46],
  };

  Object.values(base.typography).forEach((type) => {
    type.fontFamily = 'new-frank, Helvetica, Arial, sans-serif';
  });

  const theme = merge({}, base, {
    mode: key,
    typography: merge(
      {},
      {
        fontFamily: ['new-frank', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      },
      legacyTypography,
      base.typography
    ),
    palette: merge({}, legacyPalette, palette, {
      background: {
        paper: palette.background['paperElevation0'],
      },
      shadows,
      lowText: { main: palette.text.tertiary },
      midText: { main: palette.text.secondary },
      highText: { main: palette.text.primary ?? '#FCFDFF' },
      standard0: { main: palette.background['paperElevation0'] },
      standard1: { main: palette.background['paperElevation1'] },
      standard2: { main: palette.background['paperElevation2'] },
      indicator,
    }),
    components: {
      MuiButton: {
        defaultProps: { color: 'primary', variant: 'outlined' },
        styleOverrides: {
          root: { borderRadius: 2 },
          outlined: { borderWidth: 1, transition: 'none' },
          startIcon: {
            margin: 0,
          },
        },
        variants: [
          {
            props: { size: 'small' },
            style: {
              display: 'inline-flex',
              padding: '8px 10px',
              fontSize: 'var(--font-size-075-rem, 12px)',
              lineHeight: '13px',
              height: '32px',
              letterSpacing: '0.5px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '4px',
            },
          },
          {
            props: { size: 'large' },
            style: {
              display: 'inline-flex',
              height: '40px',
              padding: '9px 14px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '6px',
            },
          },
          {
            props: { color: 'standard0' },
            style: {
              boxShadow: shadows[26],
              color: palette.text.secondary,
              background: palette.background.paperElevation0,
              '&[disabled]': {
                color: palette.text.disabled,
                boxShadow: shadows[26],
                background: palette.background.paperElevation0,
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation0, #FFF)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation0, #1D293B)',
                boxShadow: shadows[26],
              },
              '&.active': {
                borderRadius: '2px',
                background: palette.opacblack2,
                color: palette.text.selectedbutton,
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.opacblack1,
                  boxShadow: shadows[31],
                },
                '&:hover': {
                  background: palette.opacblack3,
                  //boxShadow: shadows[31],
                },
              },
            },
          },
          {
            props: { color: 'standard1' },
            style: {
              background: palette.background.paperElevation1,
              boxShadow: shadows[27],
              color: palette.text.secondary,
              '&[disabled]': {
                color: palette.text.disabled,
                background: palette.background.paperElevation1,
                boxShadow: shadows[27],
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation1, #EAF1FC)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation1, #223147)',
                boxShadow: shadows[27],
              },
              '&.active': {
                borderRadius: '2px',
                background: palette.opacblack2,
                color: palette.text.selectedbutton,
                boxShadow: shadows[31],
                '&:hover': {
                  background: palette.opacblack3,
                },
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.opacblack1,
                  boxShadow: shadows[31],
                },
              },
            },
          },
          {
            props: { color: 'standard2' },
            style: {
              background: palette.background.paperElevation2,
              color: palette.text.secondary,
              boxShadow: shadows[28],
              '&[disabled]': {
                color: palette.text.disabled,
                background: palette.background.paperElevation2,
                boxShadow: shadows[28],
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation2, #E1EBFA)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation2, #283852)',
                boxShadow: shadows[28],
              },
              '&.active': {
                borderRadius: '2px',
                background: palette.opacblack2,
                color: palette.text.selectedbutton,
                boxShadow: shadows[31],
                '&:hover': {
                  background: palette.opacblack3,
                },
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.opacblack1,
                  boxShadow: shadows[31],
                },
              },
            },
          },
          {
            props: { variant: 'contained', color: 'primary' },
            style: {
              background: palette.primary.main,
              boxShadow: shadows[30],
              color: palette.primary.contrastText,
              '&[disabled]': {
                background: palette.background.paperElevation0,
                boxShadow: shadows[26],
                color: palette.text.disabled,
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), var(--primary-main, #00B2A9)'
                  : 'linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), var(--primary-main, #00B2A9)',
                boxShadow: shadows[30],
              },
              '&.active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacblack3, rgba(0, 96, 242, 0.20)) 0%, var(--opacblack3, rgba(0, 96, 242, 0.20)) 100%), var(--primary-main, #00B2A9)'
                  : 'linear-gradient(0deg, var(--opacblack3, rgba(0, 0, 0, 0.50)) 0%, var(--opacblack3, rgba(0, 0, 0, 0.50)) 100%), var(--primary-main, #00B2A9)',
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.opacblack1,
                  boxShadow: shadows[31],
                },
              },
            },
          },
          {
            props: { color: 'error' },
            style: {
              color: palette.error.contrastText,
              background: palette.error.main,
              boxShadow: shadows[33],
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), var(--error-main, #E3574F)'
                  : 'linear-gradient(0deg, var(--opacwhite1, rgba(204, 224, 255, 0.06)) 0%, var(--opacwhite1, rgba(204, 224, 255, 0.06)) 100%), linear-gradient(0deg, var(--opacwhite1, rgba(204, 224, 255, 0.06)) 0%, var(--opacwhite1, rgba(204, 224, 255, 0.06)) 100%), var(--error-main, #ED524A)',
                boxShadow: shadows[33],
              },
              '&[disabled]': {
                color: palette.text.disabled,
                background: palette.background.paperElevation0,
                boxShadow: shadows[26],
              },
              '&.active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacblack3, rgba(0, 96, 242, 0.20)) 0%, var(--opacblack3, rgba(0, 96, 242, 0.20)) 100%), var(--error-main, #E3574F)'
                  : 'linear-gradient(0deg, var(--opacblack3, rgba(0, 0, 0, 0.50)) 0%, var(--opacblack3, rgba(0, 0, 0, 0.50)) 100%), var(--error-main, #ED524A)',
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  background: palette.background.paperElevation0,
                  color: palette.text.disabled,
                },
              },
            },
          },
          {
            props: { color: 'blue' },
            style: {
              color: palette.info.contrastText,
              background: palette.info.main,
              boxShadow: shadows[34],
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 0%, var(--opacwhite2, rgba(140, 158, 184, 0.12)) 100%), var(--info-main, #0288D1)'
                  : 'linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), var(--info-main, #29B6F6)',
                boxShadow: shadows[34],
              },
              '&[disabled]': {
                color: palette.text.disabled,
                background: palette.background.paperElevation0,
                boxShadow: shadows[26],
              },
              '&.active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacblack3, rgba(0, 96, 242, 0.20)) 0%, var(--opacblack3, rgba(0, 96, 242, 0.20)) 100%), var(--info-main, #0288D1)'
                  : 'linear-gradient(0deg, var(--opacblack3, rgba(0, 0, 0, 0.50)) 0%, var(--opacblack3, rgba(0, 0, 0, 0.50)) 100%), var(--info-main, #29B6F6)',
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  background: palette.background.paperElevation0,
                  color: palette.text.disabled,
                },
              },
            },
          },
          {
            props: { color: 'green' },
            style: {
              color: palette.success.contrastText,
              background: palette.success.main,
              boxShadow: shadows[35],
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), var(--success-main, #47B56F)'
                  : 'linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), linear-gradient(0deg, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 0%, var(--opacwhite2, rgba(204, 224, 255, 0.12)) 100%), var(--success-main, #47B56F)',
                boxShadow: shadows[35],
              },
              '&[disabled]': {
                color: palette.text.disabled,
                background: palette.background.paperElevation0,
                boxShadow: shadows[26],
              },
              '&.active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opacblack3, rgba(0, 0, 0, 0.50)) 0%, var(--opacblack3, rgba(0, 0, 0, 0.50)) 100%), var(--success-main, #47B56F)'
                  : 'linear-gradient(0deg, var(--opacblack3, rgba(0, 0, 0, 0.50)) 0%, var(--opacblack3, rgba(0, 0, 0, 0.50)) 100%), var(--success-main, #47B56F)',
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  background: palette.background.paperElevation0,
                  color: palette.text.disabled,
                },
              },
            },
          },
          {
            props: { variant: 'outlined', color: 'primary' },
            style: {
              color: palette.primary.main,
              border: '1px solid var(--primary-main, #00B2A9)',
              '&:hover': {
                background: palette.opacprim1,
              },
              '&[disabled]': {
                color: palette.text.disabled,
                borderColor: palette.text.disabled,
              },
              '&:active': {
                color: palette.primary.main,
                border: '1px solid var(--primary-main, #00B2A9)',
                background: palette.opacprim2,
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  border: '1px solid var(--text-disabled, #4A5A75)',
                },
              },
            },
          },
          {
            props: { variant: 'outlined', color: 'lowText' },
            style: {
              borderColor: palette.text.tertiary,
              color: palette.text.tertiary,
              '&:hover': {
                color: palette.text.secondary,
                borderColor: palette.text.secondary,
                backgroundColor: palette.opacwhite1,
              },
              '&:active': {
                color: palette.text.primary ?? '#fff',
                borderColor: palette.text.primary ?? '#fff',
                backgroundColor: palette.opacwhite2,
              },
              '&[disabled]': {
                color: palette.text.disabled,
                borderColor: palette.text.disabled,
              },
            },
          },
          {
            props: { variant: 'outlined', color: 'midText' },
            style: {
              color: palette.text.secondary,
              borderColor: palette.text.secondary,
              '&:hover': {
                color: palette.text.primary ?? '#fff',
                borderColor: palette.text.primary ?? '#fff',
                backgroundColor: palette.opacwhite1,
              },
              '&:active': {
                color: palette.text.primary ?? '#fff',
                borderColor: palette.text.primary ?? '#fff',
                backgroundColor: palette.opacwhite2,
              },
              '&[disabled]': {
                color: palette.text.disabled,
                borderColor: palette.text.disabled,
              },
            },
          },
          {
            props: { variant: 'outlined', color: 'highText' },
            style: {
              color: palette.text.primary,
              borderColor: palette.text.primary,
              '&:hover': {
                color: palette.text.primary ?? '#fff',
                borderColor: palette.text.primary ?? '#fff',
                backgroundColor: palette.opacwhite1,
              },
              '&:active': {
                color: palette.text.primary ?? '#fff',
                borderColor: palette.text.primary ?? '#fff',
                backgroundColor: palette.opacwhite2,
              },
              '&[disabled]': {
                color: palette.text.disabled,
                borderColor: palette.text.disabled,
              },
            },
          },
        ],
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: { color: palette.text.primary },
        },
      },
      MuiChip: {
        defaultProps: { color: 'primary', variant: 'outlined' },
        styleOverrides: {
          root: { borderRadius: 4 },
          outlined: { borderWidth: 1, borderColor: palette.divider3 },
        },
        variants: [
          // prettier-ignore
          {
              props: {size: 'small'},
              style:{
                display: 'inline-flex',
                padding: '12px 8px 12px 6px;',
                height: '32px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '2px',
              }
            },
          {
            props: { size: 'large' },
            style: {
              display: 'inline-flex',
              height: '40px',
              padding: '12px 14px 12px 12px;',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '4px',
            },
          },
          {
            props: { variant: 'filled', color: 'standard0' },
            style: {
              background: palette.background.paperElevation0,
              boxShadow: shadows[26],
              color: palette.text.secondary,
              '&.Mui-disabled': {
                color: palette.text.disabled,
                opacity: 'unset',
                '& .MuiChip-icon': {
                  color: palette.text.disabled,
                },
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation0, #FFF)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation0, #1D293B)',
              },
              '&:active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac2, rgba(0, 96, 242, 0.12)) 0%, var(--opac2, rgba(0, 96, 242, 0.12)) 100%), var(--background-paperElevation0, #FFF)'
                  : 'linear-gradient(0deg, var(--opac2, rgba(128, 177, 255, 0.12)) 0%, var(--opac2, rgba(128, 177, 255, 0.12)) 100%), var(--background-paperElevation0, #1D293B)',
              },
              '&.active': {
                background: palette.outlineselected2,
                color: palette.primary.main,
                boxShadow: shadows[31],

                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.outlineselected1,
                  opacity: 'unset',
                  '& .MuiChip-icon': {
                    color: palette.text.disabled,
                  },
                },
                '&:hover': {
                  background: light
                    ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--outlineselected2, rgba(0, 178, 169, 0.12))'
                    : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--outlineselected2, rgba(0, 0, 0, 0.30))',
                },
              },
            },
          },
          {
            props: { variant: 'filled', color: 'standard1' },
            style: {
              background: palette.background.paperElevation1,
              boxShadow: shadows[27],
              color: palette.text.secondary,
              '&.Mui-disabled': {
                color: palette.text.disabled,
                opacity: 'unset',
                '& .MuiChip-icon': {
                  color: palette.text.disabled,
                },
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation1, #EAF1FC)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation1, #223147)',
              },
              '&:active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac2, rgba(0, 96, 242, 0.12)) 0%, var(--opac2, rgba(0, 96, 242, 0.12)) 100%), var(--background-paperElevation1, #EAF1FC)'
                  : 'linear-gradient(0deg, var(--opac2, rgba(128, 177, 255, 0.12)) 0%, var(--opac2, rgba(128, 177, 255, 0.12)) 100%), var(--background-paperElevation1, #223147)',
              },
              '&.active': {
                background: palette.outlineselected2,
                color: palette.primary.main,
                boxShadow: shadows[31],

                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.outlineselected1,
                  opacity: 'unset',
                  '& .MuiChip-icon': {
                    color: palette.text.disabled,
                  },
                },
                '&:hover': {
                  background: light
                    ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--outlineselected2, rgba(0, 178, 169, 0.12))'
                    : ' linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--outlineselected2, rgba(0, 0, 0, 0.30))',
                },
              },
            },
          },
          {
            props: { variant: 'filled', color: 'standard2' },
            style: {
              background: palette.background.paperElevation2,
              boxShadow: shadows[28],
              color: palette.text.secondary,
              '&.Mui-disabled': {
                color: palette.text.disabled,
                opacity: 'unset',
                '& .MuiChip-icon': {
                  color: palette.text.disabled,
                },
              },
              '&:hover': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--background-paperElevation2, #E1EBFA)'
                  : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--background-paperElevation2, #283852)',
              },
              '&:active': {
                background: light
                  ? 'linear-gradient(0deg, var(--opac2, rgba(0, 96, 242, 0.12)) 0%, var(--opac2, rgba(0, 96, 242, 0.12)) 100%), var(--background-paperElevation2, #E1EBFA)'
                  : 'linear-gradient(0deg, var(--opac2, rgba(128, 177, 255, 0.12)) 0%, var(--opac2, rgba(128, 177, 255, 0.12)) 100%), var(--background-paperElevation2, #283852)',
              },
              '&.active': {
                background: palette.outlineselected2,
                color: palette.primary.main,
                boxShadow: shadows[31],
                '&.Mui-disabled': {
                  color: palette.text.disabled,
                  background: palette.outlineselected1,
                  opacity: 'unset',
                  '& .MuiChip-icon': {
                    color: palette.text.disabled,
                  },
                },
                '&:hover': {
                  background: light
                    ? 'linear-gradient(0deg, var(--opac1, rgba(0, 96, 242, 0.06)) 0%, var(--opac1, rgba(0, 96, 242, 0.06)) 100%), var(--outlineselected2, rgba(0, 178, 169, 0.12))'
                    : 'linear-gradient(0deg, var(--opac1, rgba(128, 177, 255, 0.06)) 0%, var(--opac1, rgba(128, 177, 255, 0.06)) 100%), var(--outlineselected2, rgba(0, 0, 0, 0.30))',
                },
              },
            },
          },
          {
            props: { variant: 'outlined' },
            style: {
              '& .MuiChip-label': {
                color: palette.text.secondary,
              },
              '&.Mui-disabled': {
                border: `1px solid ${palette.text.disabled}`,
                opacity: 'unset',
                '& .MuiChip-label': {
                  color: palette.text.disabled,
                },
                '&.MuiChip-root .MuiChip-icon': {
                  color: palette.text.disabled,
                },
              },
              '&:hover': {
                border: `1px solid ${palette.primary.main}`,
              },
              '&:active': {
                border: `1px solid ${palette.primary.main}`,
                background: palette.outlineselected1,
              },
              '&.active': {
                borderColor: palette.primary.main,
                background: palette.outlineselected2,
                '& .MuiChip-label': {
                  color: palette.primary.main,
                },

                '&:hover': {
                  background: light
                    ? 'linear-gradient(0deg, var(--outlineselected2, rgba(0, 178, 169, 0.12)) 0%, var(--outlineselected2, rgba(0, 178, 169, 0.12)) 100%), var(--outlineselected2, rgba(0, 178, 169, 0.12))'
                    : 'linear-gradient(0deg, var(--outlineselected2, rgba(0, 0, 0, 0.30)) 0%, var(--outlineselected2, rgba(0, 0, 0, 0.30)) 100%), var(--outlineselected2, rgba(0, 0, 0, 0.30))',
                  borderColor: palette.primary.main,
                },
                '&.Mui-disabled': {
                  borderColor: palette.text.disabled,
                  '& .MuiChip-label': {
                    color: palette.text.disabled,
                  },
                  opacity: 'unset',
                  '&.MuiChip-root .MuiChip-icon': {
                    color: palette.text.disabled,
                  },
                },
              },
            },
          },
        ],
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: palette._components.tooltip.fill,
            color: palette.text.primary,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            '& .MuiTabScrollButton-horizontal.Mui-disabled': {
              display: 'none',
            },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            '& ::-webkit-scrollbar': {
              width: '9px',
              height: '9px',
            },
            '& ::-webkit-scrollbar-track': {
              background: palette.opac1, // was #2d405e
              borderRadius: '10px',
            },
            '& ::-webkit-scrollbar-thumb': {
              background: palette.opac2, // was #121c29
              borderRadius: '10px',
            },
            '& ::-webkit-scrollbar-thumb:hover': {
              background: palette.background.paperElevation2, // was #0f1926
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiFilledInput-root': {
              backgroundColor: light ? 'rgba(0, 96, 242, 0.06)' : 'rgba(128, 177, 255, 0.06)',
              '&:hover': {
                backgroundColor: light ? 'rgba(0, 96, 242, 0.09)' : 'rgba(128, 177, 255, 0.12)',
              },
              '&.Mui-focused': {
                backgroundColor: light ? 'rgba(0, 96, 242, 0.06)' : 'rgba(128, 177, 255, 0.06)',
              },
              '&.Mui-disabled': {
                backgroundColor: light ? 'rgba(0, 96, 242, 0.03)' : 'rgba(128, 177, 255, 0.04)',
                color: palette.text.disabled,
              },
              '&:before': {
                borderBottom: `1px solid ${light ? '#8AAFE5' : '#6E7C94'}`,
                opacity: '42%',
              },
              '&:hover:before': {
                opacity: '100%',
              },
              '&.Mui-disabled:before': {
                opacity: '42%',
              },
            },
          },
        },
      },
    },
  } as ThemeOptions);
  // Standalone providers also need MUI's default palette, transitions and helpers.
  themes[key] = createTheme(theme);
});

export const { dark: darkTheme, light: lightTheme } = themes;
export const theme = createTheme({
  colorSchemes: themes,
  // cssVariables: true,
  /* cssVariables: {
    colorSchemeSelector: "class",
  }, */
});
